/* unplugin-vue-components disabled */import script from "./merchandise-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./merchandise-modal.vue?vue&type=script&setup=true&lang=js"

import "./merchandise-modal.vue?vue&type=style&index=0&id=880fd0e0&lang=scss"

const __exports__ = script;

export default __exports__